// Reads the selected photo's natural dimensions into the hidden width/height
// inputs so the server can validate minimal dimensions before upload.
// Same mechanics as CollectionImageForm, with the owner photo form's names.
const UserVeloFriendlyPhotoForm = {
  cleanup: () => {},
  mountInputs(thisEl: any): null | (() => void) {
    const imageInput = thisEl.elements['photo']
    const dropzone = thisEl.querySelector('#velo-friendly-photo-upload-dropzone')

    const widthInput = thisEl.elements['photo[width]']
    const heightInput = thisEl.elements['photo[height]']

    if (!imageInput) {
      throw new Error('photo input not found')
    }

    if (!widthInput) {
      throw new Error('photo[width] input not found')
    }

    if (!heightInput) {
      throw new Error('photo[height] input not found')
    }

    async function handleImageChange() {
      const file = imageInput.files[0]

      if (!file) {
        return
      }

      const img = new Image()
      img.src = URL.createObjectURL(file)
      await img.decode()

      widthInput.value = img.width.toString()
      heightInput.value = img.height.toString()

      widthInput.dispatchEvent(new CustomEvent('change', { bubbles: true }))
    }

    function handleDrop(e: DragEvent) {
      e.preventDefault()
      if (!e.dataTransfer?.files.length) return

      const file = e.dataTransfer.files[0]
      if (!file) return

      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      imageInput.files = dataTransfer.files
      handleImageChange()
    }

    imageInput.addEventListener('change', handleImageChange)
    dropzone?.addEventListener('drop', handleDrop)

    return () => {
      imageInput.removeEventListener('change', handleImageChange)
      dropzone?.removeEventListener('drop', handleDrop)
    }
  },
  mounted() {
    const cleanup = this.mountInputs((this as any).el)

    if (cleanup) {
      this.cleanup = cleanup
    }
  },
  updated() {
    this.cleanup()
    const cleanup = this.mountInputs((this as any).el)

    if (cleanup) {
      this.cleanup = cleanup
    }
  },
}

export { UserVeloFriendlyPhotoForm }
